import bigPlayIcon from 'icons/big_play_button.svg';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Icon from '../Icon/Icon';
import {
  BigPlayButtonStyled,
  StyledIconWrap,
} from './styles/BigPlayButtonStyled';

const BigPlayButton = ({
  playerWidth,
  backgroundPoster = null,
  onClick = () => void 0,
  onMouseDown = () => void 0,
}) => (
  <BigPlayButtonStyled
    onClickCapture={onClick}
    onMouseDownCapture={onMouseDown}
    backgroundPoster={backgroundPoster}
  >
    <StyledIconWrap iconSize={playerWidth > 960 ? 72 : 48}>
      <Icon name={bigPlayIcon} />
    </StyledIconWrap>
  </BigPlayButtonStyled>
);

BigPlayButton.propTypes = {
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  backgroundPoster: PropTypes.string,
  playerWidth: PropTypes.number.isRequired,
};

export default memo(BigPlayButton);
